// ModalDetalleServicio.js
import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Grid,
    Chip
} from "@mui/material";

export default function ModalDetalleServicio({ open, servicio, onClose }) {
    if (!servicio) return null;

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Detalle del servicio</DialogTitle>

            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            label="Nombre"
                            value={servicio.nombre}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            label="Descripción"
                            value={servicio.descripcion || ""}
                            fullWidth
                            multiline
                            rows={3}
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <TextField
                            label="Precio"
                            value={`$${servicio.precio}`}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <TextField
                            label="Proveedor"
                            value={servicio.proveedor || "—"}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <TextField
                            label="Estado"
                            value={servicio.isDisable ? "Inactivo" : "Activo"}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <Chip
                            label={servicio.isDisable ? "DESHABILITADO" : "HABILITADO"}
                            color={servicio.isDisable ? "error" : "success"}
                            sx={{ mt: 1 }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>Cerrar</Button>
            </DialogActions>
        </Dialog>
    );
}
